"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const flag_styles_1 = require("./flag.styles");
exports.Flag = props => {
    return React.createElement(flag_styles_1.StyledText, { className: props.className }, props.children);
};
//# sourceMappingURL=flag.js.map